import processReport from '@/assets/js/report/order_purchase'
export default {
  methods: {
    async genereatePurchaseReportContent (getObj) {
      if (!getObj) getObj = {}
      let customerLang = (getObj && getObj.customer_language) ? getObj.customer_language : this.$i18n.locale
      let lang = this.$i18n.messages[customerLang].message
      if (getObj) {
        let headers = [{ text: lang.product.number, value: 'number', width: '10%' },
          { text: lang.whOrder.from, value: 'supplier_name', width: '34%' },
          { text: lang.whOrder.requested, value: 'estimated_date', width: '13%' },
          { text: lang.whOrder.confirmed, value: 'confirmed_date', width: '20%' },
          { text: 'Ok', value: '', width: '10%' },
          { text: '', value: '', width: '20%' }
        ]
        let products = await this.getOrderPurchaseList(getObj.id)
        let translationData = {
          confirm: lang.order.orderlist,
          number: lang.order.orderNumber,
          customer: lang.order.customer,
          contact: lang.order.yourContactPerson,
          deliveryAddress: lang.orders.deliveryAddress,
          responsible: lang.deviations.responsible,
          ourreference: lang.orders.ourReference,
          yourreference: lang.orders.yourReference,
          installationWeek: lang.orders.installationWeek,
          yourOrderNumber: lang.orders.yourOrderNumber,
          offerdate: lang.orders.offerDate,
          orderdate: lang.whOrder.orderDate,
          deliverydate: lang.order.shippingDate,
          shipment: lang.customer.shipmentPurchase,
          invoiceTo: lang.orders.invoiceTo,
          invoiceAddress: lang.orders.invoiceAddress,
          days: lang.common.days,
          saleRef: lang.invoiceReport.saleRef,
          customerNum: lang.unimicro.customerNumber,
          internalCom: lang.whOrder.internalCom,
          orderSum: lang.orders.orderTotal,
          installWeek: lang.orders.installationWeek,
          sendingWeek: lang.orders.sendFromWH
        }
        let getBase64Content = processReport(headers, products, getObj, translationData)
        return getBase64Content
      }
    },
    getOrderPurchaseList (id) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `ordermaterials/get_materials_purchaselist/${id}`)
          .then((response) => {
            if (response.data) {
              const allOrders = response.data
              let transformList = { date: { list: ['orderdate', 'estimated_date', 'confirmed_date'], from: 'DD.MM.YYYYTH:mm:ss', to: 'DD.MM.YYYY' } }
              let model = this.$_formatListModel(allOrders, transformList)
              var emptyArray = []
              for (let i = 0; i <= 15; i++) {
                emptyArray.push({})
              }
              model.push(...emptyArray)
              resolve(model)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
